<template>
  <v-container fluid>
    <v-row
      justify="end"
      align="center"
    >
      <v-col
        cols="2"
        align="right"
      >
        <v-btn-toggle
          v-model="tipoVista"
          rounded
          background-color="white"
          mandatory
        >
          <v-btn
            rounded
            color="secondary"
          >
            Tabla
          </v-btn>
          <v-btn
            rounded
            color="secondary"
          >
            Calendario
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="tipoVista === 0"
        cols="12"
      >
        <v-card
          color="primary"
          class="card"
        >
          <v-card-title>
            <v-container>
              <v-row align="center">
                <v-col cols="4">
                  <div class="text-h6 font-weight-bold">
                    Tabla de programaciones
                  </div>
                </v-col>
                <v-spacer />
                <v-col align="right">
                  <formato-programacion-component />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="search"
                    label="Buscar"
                    dense
                    rounded
                    filled
                    color="secondary"
                    background-color="primary"
                    append-icon="mdi-magnify"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="programaciones"
            class="transparent"
            :search="search"
          >
            <template #[`item.nombre`]="{ item }">
              <div class="text-subtitle-2">
                {{ getFullName(item.Expediente.Personal) }}
              </div>
            </template>
            <template #[`item.opciones`]="{ item }">
              <v-btn
                icon
                color="secondary"
                @click="openInformacionProgramacionDialog(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title>
            <div class="text-h6 font-weight-bold">
              Calendario de programaciones
            </div>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-chip-group
                  v-model="filtroCalendario"
                  multiple
                >
                  <v-chip
                    label
                    filter
                    color="green"
                    class="white--text mx-2"
                  >
                    Evaluación médica / toxicológica
                  </v-chip>
                  <v-chip
                    label
                    filter
                    color="purple"
                    class="white--text mx-2"
                  >
                    Evaluación psicológica
                  </v-chip>
                  <v-chip
                    label
                    filter
                    color="red"
                    class="white--text mx-2"
                  >
                    Evaluación polígrafo
                  </v-chip>
                  <v-chip
                    label
                    filter
                    color="blue"
                    class="white--text mx-2"
                  >
                    Entrevista ISE
                  </v-chip>
                </v-chip-group>
              </v-row>
              <v-row justify="space-between">
                <v-col cols="4">
                  <v-btn
                    text
                    @click="$refs.calendar.prev()"
                  >
                    <v-icon>mdi-arrow-left</v-icon>
                    Mes anterior
                  </v-btn>
                </v-col>
                <v-col
                  cols="4"
                  align="right"
                >
                  <v-btn
                    text
                    @click="$refs.calendar.next()"
                  >
                    Mes siguiente
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
            <v-calendar
              ref="calendar"
              v-model="calendario"
              color="secondary"
              event-color="getEventColor"
              event-overlap-mode="column"
              :events="calendarCursosProgramados"
              :event-more="false"
              @click:event="mostrarEvento($event)"
            />
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :close-on-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card
                class="card rounded-0"
                color="grey lighten-4"
                min-width="350px"
                flat
              >
                <v-card-title>{{ selectedEvent.name }}</v-card-title>
                <v-card-text>
                  <div class="text-subtitle-2 font-weight-bold">
                    Evaluación: {{ selectedEvent.evaluacion }}
                  </div>
                  <div class="text-subtitle-2 font-weight-bold">
                    Fecha y hora: {{ selectedEvent.start }}
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="secondary"
                    @click="closeMenu()"
                  >
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <informacion-programacion-dialog-component
      :active="informacionProgramacionDialog"
      :programacion="selectedProgramacion"
      @close="informacionProgramacionDialog = false"
    />
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      opacity=".68"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import InformacionProgramacionDialogComponent from '../../components/programacion/InformacionProgramacionDialogComponent.vue';
import FormatoProgramacionComponent from '../../components/formatos/FormatoProgramacionComponent.vue';

export default {
  name: 'DashboardView',
  components: {
    InformacionProgramacionDialogComponent,
    FormatoProgramacionComponent,
  },

  data() {
    return {
      overlay: false,
      search: '',
      calendario: '',
      selectedOpen: false,
      selectedEvent: {},
      selectedElement: null,

      tipoVista: 0,
      filtroCalendario: [0, 1, 2, 3],
      headers: [
        { text: 'Folio', value: 'Expediente.folio', width: '5%' },
        { text: 'Nombre', value: 'nombre', width: '15%' },
        { text: 'RFC', value: 'Expediente.Personal.rfc', width: '10%' },
        { text: 'Dependencia', value: 'Expediente.Personal.unidadAnalisisTactico', width: '10%' },
        { text: 'Puesto', value: 'Expediente.Personal.unidadOperaciones', width: '10%' },
        { text: 'Motivo de evaluación', value: 'CatMotivoEvaluacion.title', width: '10%' },
        { text: 'Evaluación médica/toxicológica', value: 'fechaEvaluacionMedica', width: '10%' },
        { text: 'Evaluación psicológica', value: 'fechaEvaluacionPsicologica', width: '10%' },
        { text: 'Entrevista ISE', value: 'fechaEntrevistaIse', width: '10%' },
        { text: 'Evaluación polígrafo', value: 'fechaEvaluacionPoligrafica', width: '10%' },
        { text: 'Reagendar', value: 'opciones', width: '10%' },
      ],

      informacionProgramacionDialog: false,
      selectedProgramacion: null,
    };
  },

  computed: {
    ...mapGetters('programacionEvaluacion', {
      programaciones: 'getProgramacionesEvaluaciones',
    }),

    calendarCursosProgramados() {
      const listaEventos = [];

      this.programaciones.forEach((programacion) => {
        if (this.filtroCalendario.some((filtro) => filtro === 0)) {
          listaEventos.push({
            name: this.getFullName(programacion.Expediente.Personal),
            evaluacion: 'Médica / Toxicológica',
            color: 'green',
            start: moment(programacion.fechaEvaluacionMedica).format('YYYY-MM-DD HH:mm'),
          });
        }

        if (this.filtroCalendario.some((filtro) => filtro === 1)) {
          listaEventos.push({
            name: this.getFullName(programacion.Expediente.Personal),
            evaluacion: 'Psicológica',
            color: 'purple',
            start: moment(programacion.fechaEvaluacionPsicologica).format('YYYY-MM-DD HH:mm'),
          });
        }

        if (this.filtroCalendario.some((filtro) => filtro === 2)) {
          listaEventos.push({
            name: this.getFullName(programacion.Expediente.Personal),
            evaluacion: 'Polígrafo',
            color: 'red',
            start: moment(programacion.fechaEvaluacionPoligrafica).format('YYYY-MM-DD HH:mm'),
          });
        }

        if (this.filtroCalendario.some((filtro) => filtro === 3)) {
          listaEventos.push({
            name: this.getFullName(programacion.Expediente.Personal),
            evaluacion: 'Entrevista ISE',
            color: 'blue',
            start: moment(programacion.fechaEntrevistaIse).format('YYYY-MM-DD HH:mm'),
          });
        }
      });

      return listaEventos;
    },
  },

  methods: {
    ...mapActions('derivaciones', ['fetchDerivacionesByProgramacionEvaluacion']),

    mostrarEvento(event) {
      this.selectedEvent = event.event;
      this.selectedOpen = true;
    },

    closeMenu() {
      this.selectedOpen = false;
    },

    getEventColor(event) {
      return event.color;
    },

    async openInformacionProgramacionDialog(programacion) {
      this.overlay = true;
      this.selectedProgramacion = programacion;

      await this.fetchDerivacionesByProgramacionEvaluacion(programacion.idProgramacionEvaluacion);

      this.informacionProgramacionDialog = true;
      this.overlay = false;
    },
  },
};
</script>
'
